import React from 'react';

import { CircularProgress } from '@mui/material';

const Loading: React.FC = () => (
  <div
    style={{
      position: 'fixed',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'rgba(0,0,0,0.5)',
      zIndex: '15000',
    }}
  >
    <CircularProgress size={100} />
  </div>
);

export default Loading;
